"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpLinkLibrary = exports.RenderModeType = void 0;
var HelpLinkLibraryStrings_1 = require("./HelpLinkLibraryStrings");
var RenderModeType;
(function (RenderModeType) {
    RenderModeType[RenderModeType["Default"] = 0] = "Default";
    RenderModeType["QuickHelp"] = "quickHelp";
})(RenderModeType = exports.RenderModeType || (exports.RenderModeType = {}));
var HelpLinkLibrary = /** @class */ (function () {
    function HelpLinkLibrary() {
        this.language = '';
        this.helpToken = '';
        this.edition = '';
        this.version = '';
        this.platform = '';
        this.build = '';
        this.anchor = '';
        this.renderMode = { renderModeType: RenderModeType.Default, renderModeState: false };
        this.prepStr = 'prep';
        this.proStr = 'pro';
        this.publicStr = 'public';
        this.readerStr = 'reader';
        this.phoenixStr = 'tableau-mobile-phoenix';
        this.onlineStr = 'online';
        this.serverStr = 'server';
    }
    /**
     * Method to set the language abbreviation string to be converted and used as part of a help url.
     * @param {string} language
     */
    HelpLinkLibrary.prototype.setLanguage = function (language) {
        this.language = language;
    };
    /**
     * Set the needed paramaters of language, edition, version, category (also referened as a help token),
     *
     * optional platform (Note that for online, server, and Prep the platform parameter is required),
     *
     * optional build (Note that for Prep the build parameter is required),
     *
     * optional anchor strings (Discourage to specify anchor via the code here. Contact the Tech Writer instead),
     *
     * and optional renderMode RenderMode type for generating a helpdoc page url.
     *
     * A build paramater of undefined
     * or empty string needs to be provided if the anchor paramater is used but the build parameter is not. Undefined for build and anchor parameters should
     * be used if they aren't used but a renderMode parameter is. To use renderMode it needs to be constucted with a RenderMode type
     * which is constructed with an enum of RenderModeType and a boolean.  An example constuction is as follows:
     *
     * renderMode: RenderMode = { renderModeType: RenderModeType.quickHelp, renderModeState: true };
     * @param {string} langauge
     * @param {string} edition
     * @param {string} version
     * @param {string} category
     * @param {string} platform
     * @param {string} build
     * @param {string} anchor Deprecated - Please coordinate with the Tech Writer to add the anchor. Any string hardcoded here overrides the settings by the Writer.
     * @param {RenderMode} renderMode
     */
    HelpLinkLibrary.prototype.setHelpUrl = function (langauge, edition, version, category, platform, build, anchor, renderMode) {
        this.helpToken = category;
        this.language = langauge;
        this.edition = edition;
        this.version = version;
        var validEditions = [
            this.prepStr,
            this.proStr,
            this.onlineStr,
            this.publicStr,
            this.phoenixStr,
            this.readerStr,
            this.serverStr,
        ];
        if (!validEditions.includes(edition)) {
            throw new Error(HelpLinkLibraryStrings_1.invalidEditionParamMsg);
        }
        if (platform !== undefined) {
            this.platform = platform;
        }
        if (build !== undefined) {
            this.build = build;
        }
        if (anchor !== undefined) {
            this.anchor = anchor;
        }
        if (renderMode !== undefined) {
            this.renderMode = renderMode;
        }
        if ((edition === this.serverStr && platform === undefined) || (edition === this.onlineStr && platform === undefined)) {
            throw new Error(HelpLinkLibraryStrings_1.missingPlatformParamErrorMsg);
        }
        if ((edition === this.prepStr && build === undefined) || (edition === this.prepStr && platform === undefined)) {
            throw new Error(HelpLinkLibraryStrings_1.missingPrepUrlParamErrorMsg);
        }
    };
    /**
     * This method will default to en-us if no string is set via the set string method.
     * @returns {string} Returns the converted language string given an abbreviated string provided in the setLanguage method.
     */
    HelpLinkLibrary.prototype.getLanguage = function () {
        if (this.language === '' || this.language === undefined) {
            return 'en-us';
        }
        var lowerLang = this.language.toLocaleLowerCase();
        var retval;
        if (lowerLang.length > 2 && lowerLang.includes('_')) {
            retval = lowerLang.replace('_', '-');
        }
        else if (lowerLang.includes('gb')) {
            retval = 'en-gb';
        }
        else if (lowerLang.includes('ca')) {
            retval = 'fr-ca';
        }
        else if (lowerLang.includes('se')) {
            retval = 'sv-se';
        }
        else if (lowerLang.includes('th')) {
            retval = 'th-th';
        }
        else if (lowerLang.includes('en')) {
            retval = 'en-us';
        }
        else if (lowerLang.includes('de')) {
            retval = 'de-de';
        }
        else if (lowerLang.includes('es')) {
            retval = 'es-es';
        }
        else if (lowerLang.includes('fr')) {
            retval = 'fr-fr';
        }
        else if (lowerLang.includes('it')) {
            retval = 'it-it';
        }
        else if (lowerLang.includes('ja')) {
            retval = 'ja-jp';
        }
        else if (lowerLang.includes('ko')) {
            retval = 'ko-kr';
        }
        else if (lowerLang.includes('pt')) {
            retval = 'pt-br';
        }
        else if (lowerLang.includes('tw')) {
            retval = 'zh-tw';
        }
        else if (lowerLang.includes('zh')) {
            retval = 'zh-cn';
        }
        else {
            retval = 'en-us';
        }
        return retval;
    };
    /**
     * Validate that the provided string gives a valid URL.
     * @returns {boolean} Returns whether the string is a valid URL.
     */
    HelpLinkLibrary.prototype.validateUrl = function (providedStr) {
        var pattern = new RegExp('^(https?:\\/\\/)?' +
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
            '((\\d{1,3}\\.){3}\\d{1,3}))' +
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
            '(\\?[;&a-z\\d%_.~+=-]*)?' +
            '(\\#[-a-z\\d_]*)?$', 'i');
        return !!pattern.test(providedStr);
    };
    /**
     * If no values are provided in setHelpUrl then the default return value will be https://www.tableau.com
     * Query params are sorted alphabetically to match .htaccess rules. Please do not change the order of each param.
     * @returns {string} Return a generated help url.
     */
    HelpLinkLibrary.prototype.getHelpUrl = function () {
        var retval = 'https://help.tableau.com';
        if (this.edition === this.phoenixStr) {
            retval +=
                '/forward/' +
                    this.helpToken +
                    '?' +
                    (this.anchor !== undefined && this.anchor.length > 0 ? 'anchor=' + this.anchor + '&' : '') +
                    'edition=' +
                    this.edition +
                    '&lang=' +
                    this.language +
                    (this.renderMode.renderModeType !== RenderModeType.Default
                        ? '&' + this.renderMode.renderModeType.toString() + '=' + this.renderMode.renderModeState.toString()
                        : '') +
                    '&version=' +
                    this.version;
        }
        else if (this.edition === this.prepStr ||
            this.edition === this.proStr ||
            this.edition === this.publicStr ||
            this.edition === this.readerStr) {
            retval +=
                '/forward/' +
                    this.helpToken +
                    '?' +
                    (this.anchor !== undefined && this.anchor.length > 0 ? 'anchor=' + this.anchor + '&' : '') +
                    'build=' +
                    this.build +
                    '&edition=' +
                    this.edition +
                    '&lang=' +
                    this.language +
                    '&platform=' +
                    this.platform +
                    (this.renderMode.renderModeType !== RenderModeType.Default
                        ? '&' + this.renderMode.renderModeType.toString() + '=' + this.renderMode.renderModeState.toString()
                        : '') +
                    '&version=' +
                    this.version;
        }
        else if (this.edition.includes(this.serverStr) || this.edition.includes(this.onlineStr)) {
            retval +=
                '/forward/' +
                    this.helpToken +
                    '?' +
                    (this.anchor !== undefined && this.anchor.length > 0 ? 'anchor=' + this.anchor + '&' : '') +
                    'edition=' +
                    this.edition +
                    '&lang=' +
                    this.language +
                    '&platform=' +
                    this.platform +
                    (this.renderMode.renderModeType !== RenderModeType.Default
                        ? '&' + this.renderMode.renderModeType.toString() + '=' + this.renderMode.renderModeState.toString()
                        : '') +
                    '&version=' +
                    this.version;
        }
        if (!this.validateUrl(retval)) {
            throw new Error(HelpLinkLibraryStrings_1.invalidUrlErrorMsg);
        }
        return retval;
    };
    return HelpLinkLibrary;
}());
exports.HelpLinkLibrary = HelpLinkLibrary;
//# sourceMappingURL=HelpLinkLibrary.js.map